module.exports = __webpack_public_path__ + "img/109275b.jpg";